import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useDispatch } from "react-redux";
import { authorizeGoogle, signupWithGoogle } from "../../../redux/actions/halloffame";
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';
import { toast } from "react-toastify";

const RecruiterAuth = ({ isOpen, onClose }) => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      setShowModal(true);
      document.body.style.overflow = "hidden";
    } else {
      setTimeout(() => setShowModal(false), 300); // Wait for animation
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!showModal && !isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-end justify-center transition-all duration-300 md:items-center ${isOpen ? "visible" : "invisible"
        }`}
    >
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"
          }`}
        onClick={onClose}
      />

      {/* Modal Container */}
      <div
        className={`relative w-full max-w-md overflow-hidden bg-[#0C4873] text-white shadow-2xl transition-all duration-300 md:rounded-2xl md:border md:border-slate-700 ${isOpen
          ? "translate-y-0 opacity-100 scale-100"
          : "translate-y-full opacity-0 md:translate-y-8 md:scale-95"
          } rounded-t-3xl md:translate-y-0`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full p-1 text-gray-400 hover:bg-white/10 hover:text-white transition-colors"
        >
          <X size={20} />
        </button>

        <div className="p-6 md:p-8">
          {/* Header */}
          <h2 className="mb-6 pr-8 text-xl font-bold leading-tight md:text-2xl">
            Unlock Full Candidate Profiles
          </h2>

          {/* Benefits List */}
          <div className="mb-8 space-y-4">
            <BenefitItem text="Access resumes, contact info & schedule 1-click interviews." />
            <BenefitItem text="View verified PEAKS skill scores and detailed profiles" />
            <BenefitItem text="Get early access to all future top talent!" />
          </div>

          {/* Verify Section */}
          <div className="mb-2">
            {/* <h3 className="mb-4 text-center text-sm font-semibold text-white md:text-[15px]">
              Verify Yourself As A Recruiter
            </h3> */}

            <div className="space-y-3">
              {/* <GoogleLogin
                clientId={XANO_GOOGLE_CLIENT_ID}
                render={(renderProps) => (
                  <SocialButton
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled}
                    icon={<img src="https://assets.learntube.ai/files/halloffame/flat-color-icons-google.png" alt="Google" className="h-5 w-5" /> }
                    text="Sign In With Google"
                  />
                )}
                onSuccess={handleGoogleResponse}
                onFailure={handleGoogleResponse}
                cookiePolicy={"single_host_origin"}
              /> */}

              <SocialButton
                onClick={() => {
                  dispatch(authorizeGoogle((authorization_url) => {

                    const width = 500;
                    const height = 600;
                    const left = window.screen.width / 2 - width / 2;
                    const top = window.screen.height / 2 - height / 2;

                    // open google login page with authorization_url in modal window
                    const newWindow = window.open(
                      authorization_url,
                      '_blank',
                      `width=${width},height=${height},top=${top},left=${left}`
                    );

                    const timer = setInterval(() => {
                      if (newWindow.closed) {
                        clearInterval(timer);
                        return;
                      }

                      try {
                        const currentUrl = newWindow.location.href;
                        const url = new URL(currentUrl);
                        const code = url.searchParams.get("code");
                        const state = url.searchParams.get("state");

                        if (code && state) {
                          newWindow.close();
                          clearInterval(timer);

                          dispatch(signupWithGoogle(code, state, (data) => {
                            console.log("sign up with google", data);
                            // Mixpanel.identify(data?.email);
                            if (!data?.onboarding_required) {
                              toast.success("Signed In Successfully!");
                            }
                            Mixpanel.track(Constants.Mixpanel.RECRUITER_AUTH_SUCCESS);
                            onClose();
                          }, (err) => {
                            // console.error("sign up with google failed", err);
                          }));
                        }
                      } catch (e) {
                        // Cross-origin error, ignore
                      }
                    }, 500);

                  }, (err) => {
                    console.error("Authorization failed", err);
                  }));
                }}
                icon={<img src="https://assets.learntube.ai/files/halloffame/flat-color-icons-google.png" alt="Google" className="h-5 w-5" />}
                text="Sign In With Google"
              />

              {/* <SocialButton
                onClick={onLinkedInLogin}
                icon={<FontAwesomeIcon icon={faLinkedin} className="text-xl text-[#0077B5]" />}
                text="Sign In With LinkedIn"
              /> */}
            </div>
          </div>

          {/* Footer Link */}
          {/* <div className="mt-6 text-center">
             <span className="text-sm text-gray-400">OR </span>
             <button
                onClick={onEmailLogin}
                className="text-sm font-medium text-white hover:underline ml-1"
             >
                Sign In With Email
             </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const BenefitItem = ({ text }) => (
  <div className="flex items-start gap-3">
    <div className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center">
      <img
        src="https://assets.learntube.ai/files/halloffame/recruiter/Check-10.svg"
        alt="check"
        className="h-3.5 w-3.5"
      />
    </div>
    <p className="text-sm leading-snug text-gray-300">{text}</p>
  </div>
);

const SocialButton = ({ onClick, icon, fallbackIcon, text, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="relative flex w-full items-center justify-center gap-3 rounded-xl bg-white py-3 px-4 font-bold text-gray-900 transition-transform hover:scale-[1.01] active:scale-[0.98] hover:bg-gray-50 disabled:opacity-50 disabled:hover:scale-100"
  >
    {icon}
    {fallbackIcon && <span style={{ display: 'none' }}>{fallbackIcon}</span>}
    <span>{text}</span>
  </button>
);

export default RecruiterAuth;
